import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import CommonTypeEditor from "./CommonTypeEditor";
import ImageFormatSelector from "./ImageFormatSelector";
import { COMPONENT_TYPES } from "../../../constants/componentType";
import {
  ADDITIONNAL_IMAGE_FORMATS,
  DEFAULT_IMAGE_FORMATS,
  IMAGE_FORMATS,
} from "../../../constants/ratio";
import { getComponentByType } from "../../../utils/data/Architecture";

import type { JSX } from "react";

import type {
  ImageFormatComponent,
  PlatformComponent,
} from "../../../api/ProjectAPI.types";
import type { ImageFormat } from "../../../constants/ratio";

interface CastingPageEditorProps {
  components: PlatformComponent[];
  onChangeComponents: (
    updatedComponents: PlatformComponent[],
    disableDataChange?: boolean,
  ) => void;
}

function CastingPageEditor({
  components,
  onChangeComponents,
}: CastingPageEditorProps): JSX.Element {
  const { t } = useTranslation("editor-platform");
  const { IMAGE_FORMAT } = COMPONENT_TYPES;
  const { FORMAT_1_1_ROUND } = IMAGE_FORMATS;

  const [castingImageFormatSelected, setCastingImageFormatSelected] =
    useState<ImageFormat>();

  const imageFormatComponent: ImageFormatComponent = getComponentByType(
    components,
    IMAGE_FORMAT,
  );

  const handleClick = (ratio: ImageFormat): void => {
    const updatedComponent = components.map((component) => {
      if (component.type === IMAGE_FORMAT) {
        return {
          ...component,
          params: { ratio },
        };
      }
      return component;
    });

    onChangeComponents(updatedComponent);
    setCastingImageFormatSelected(ratio);
  };

  useEffect(() => {
    if (imageFormatComponent) {
      setCastingImageFormatSelected(
        imageFormatComponent.params?.ratio || FORMAT_1_1_ROUND,
      );
    }
  }, [FORMAT_1_1_ROUND, imageFormatComponent]);

  return (
    <React.Fragment>
      <div className="editor-tile-container">
        <div className="pt-[0.625rem]">
          <ImageFormatSelector
            onChangeRatio={handleClick}
            selected={castingImageFormatSelected}
            title={t("pictureRatioCasting")}
            imageFormatList={[
              ...DEFAULT_IMAGE_FORMATS,
              ...ADDITIONNAL_IMAGE_FORMATS,
              IMAGE_FORMATS.FORMAT_1_1_ROUND,
            ]}
          />
        </div>
      </div>
      <CommonTypeEditor
        allowWidget
        components={components}
        onChangeComponents={onChangeComponents}
        pageType="casting"
        imageFormatList={[
          ...DEFAULT_IMAGE_FORMATS,
          ...ADDITIONNAL_IMAGE_FORMATS,
        ]}
      />
    </React.Fragment>
  );
}

export default CastingPageEditor;
